module.exports = __webpack_public_path__ + "img/一星特级大师@2x.9dc97b09.png";